<template>
  <div class="rendan">
    <div class="rendanFormula">
      <!--图标-->
      <svg class="icon money" aria-hidden="true">
        <use xlink:href="#icon-jinpai"></use>
      </svg>
      <div class="formulaBox">
        <span class="formulaNum">0</span>
        <span class="formulaDetail">来款金额</span>
      </div>
      <svg class="icon operator" aria-hidden="true">
        <use xlink:href="#icon-tianjiajihua"></use>
      </svg>
      <div class="formulaBox">
        <span class="formulaNum">0</span>
        <span class="formulaDetail">冲红发票金额</span>
      </div>
      <svg class="icon operator" aria-hidden="true">
        <use xlink:href="#icon-tianjiajihua"></use>
      </svg>
      <div class="formulaBox">
        <span class="formulaNum">0</span>
        <span class="formulaDetail">发票金额</span>
      </div>
      <svg class="icon operator" aria-hidden="true">
        <use xlink:href="#icon-tianjiajihua"></use>
      </svg>
      <div class="formulaBox">
        <span class="formulaNum">0</span>
        <span class="formulaDetail">转付退款金额</span>
      </div>
    </div>
    <div class="rendanData">
      <div class="rendanTitle">
        <span>发票列表</span>
      </div>
      <div class="rendanBox"></div>
    </div>
    <div class="rendanData">
      <div class="rendanTitle">
        <div class="cusList">
          <span>客户来款列表</span>
          <el-checkbox v-model="deposit">显示留存款</el-checkbox>
        </div>
      </div>
      <div class="rendanBox"></div>
    </div>
    <div class="rendanData">
      <div class="rendanTitle">
        <span>退款转付单</span>
        <div class="rendanbtn">
          <el-button type="primary" size="mini">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-baocun"></use>
            </svg>
            新增
          </el-button>
          <el-button type="primary" size="mini">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-baocun"></use>
            </svg>
            修改
          </el-button>
          <el-button type="primary" size="mini">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-baocun"></use>
            </svg>
            删除
          </el-button>
          <el-button class="emptyBtnStyle" size="mini">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-quxiao"></use>
            </svg>
            自定义
          </el-button>
        </div>
      </div>
      <div class="rendanBox">

      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "rendanDetail",
    data(){
      return{
        deposit:false,
      }
    }
  };
</script>

<style scoped>
  .rendanFormula {
    width: fit-content;
    height: 80px;
    background-color: #fff4d8;
    border-radius: 10px;
    margin: 0 auto;
    padding: 10px 30px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }

  .money {
    font-size: 62px;
    margin-right: 45px;
  }

  .formulaBox {
    display: flex;
    flex-direction: column;
    text-align: center;
  }

  .formulaNum {
    color: #FF4800;
    font-size: 24px;
    line-height: 40px;
  }

  .formulaDetail {
    color: #999999;
    font-size: 12px;
    line-height: 18px;
  }

  .operator {
    margin: 0 30px;
  }

  .rendanTitle {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #dddddd;
  }
 .rendanTitle span{
    color:#000000;
    font-size: 16px;
   line-height: 36px;
   margin-right: 40px;
  }
.rendanBox{
  padding: 20px 0;
}
  .rendanTitle >>> .el-checkbox{
    color:#FF7200;
  }
</style>

